//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { ApiKeyMode } from './Enums';

export class ApiKeySearchOptions extends ItemBase {
    IDs: string[] = [];
    MinCreatedDate: string | null = null;
    MaxCreatedDate: string | null = null;
    SearchText: string | null = null;
    Modes: ApiKeyMode[] = [];
    Enabled: boolean | null = null;
    MinLastUsedDate: string | null = null;
    MaxLastUsedDate: string | null = null;

    constructor(initializer?: Partial<ApiKeySearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "ApiKeySearchOptions";
}
